import * as React from "react";
import {
  ActivityFragment,
  CampaignMinimalFragment,
  UserMinimalFragment,
} from "../../../graphql/fragments";
import useTranslations from "../../../hooks/useTranslations";
import { Link } from "../../wombat-ui";
import Avatar from "../../wombat-ui/Avatar";
import { Span } from "../../wombat-ui/components/Typography";
import Activity from "../ActivityPlate";

type UserDocumentDeletedActivity = ActivityFragment & {
  recipient: CampaignMinimalFragment;
  trackable: UserMinimalFragment;
};

export function isUserDocumentDeletedActivity(
  q: ActivityFragment
): q is UserDocumentDeletedActivity {
  return q.key === "user.document_deleted";
}

interface UserDocumentDeletedActivityProps {
  activity: UserDocumentDeletedActivity;
}

export const UserDocumentDeletedActivity: React.FC<UserDocumentDeletedActivityProps> = ({
  activity,
}) => {
  const t = useTranslations();

  return (
    <Activity
      activity={activity}
      id="userDocumentDeletedActivity"
      visual={
        <Avatar
          src={activity.trackable.avatar}
          alt={`${activity.trackable.name} avatar`}
          type="user"
          size={10}
        />
      }
    >
      <Span className="text-sm">
        {t("activity.labels.userDocumentDeleted", {
          user: (
            <Link to={`/users/${activity.trackable.slug}`} key={activity.id}>
              {activity.trackable.name}
            </Link>
          ),
        })}
      </Span>
    </Activity>
  );
};
